export default __webpack_public_path__ + "static/media/bell.324fa48d.svg";